import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-radio-selection',
  templateUrl: './radio-selection.component.html',
  styleUrls: ['./radio-selection.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatRadioModule, MatButtonModule],
})
export class RadioSelectionComponent {
  options: any[] = [];
  selectedOption: string;

  constructor(
    public dialogRef: MatDialogRef<RadioSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.options = data;
  }

  onSubmit() {
    this.dialogRef.close(this.selectedOption);
  }
}
